import { AlertTriangle } from "lucide-react";

// Faixa da tela de Mesas quando o QR recusa todo cliente porque a loja exige
// caixa aberto e ele está fechado (achado 397, dono 03/10/2026). Na Mestre dos
// Jogos foram 7 leituras recusadas antes de alguém abrir o caixa, e nada no
// painel dizia isso. Mesmo formato do aviso de caixa fechado do Balcão; sem
// `onAbrirCaixa` (quem não tem a permissão) fica só o aviso.
export default function FaixaQrSemCaixa({ visivel, onAbrirCaixa }) {
  if (!visivel) return null;
  return (
    <div
      role="status"
      data-e2e="faixa-qr-sem-caixa"
      className="mb-3 sm:mb-6 rounded-lg bg-red-600 text-white text-sm font-bold flex items-center justify-center gap-2 px-4 py-2"
    >
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span className="min-w-0">O QR das mesas não aceita pedido com o caixa fechado</span>
      {onAbrirCaixa ? (
        <button
          type="button"
          onClick={onAbrirCaixa}
          data-e2e="faixa-qr-abrir-caixa"
          className="shrink-0 rounded-full bg-white text-red-600 px-3 py-1 text-xs font-black active:scale-95 transition"
        >
          Abrir caixa
        </button>
      ) : null}
    </div>
  );
}
